import { GeneralFilters } from 'components/GeneralFilters'
import { Base } from 'layouts'
import { InlineFilter } from './InlineFilter'
import { ConsolidationCards } from './ConsolidationCards'

export function ConsolidationHomePage() {
  return (
    <Base>
      <GeneralFilters InlineFilter={InlineFilter} showInlineFilters={false} />
      <ConsolidationCards />
    </Base>
  )
}
